<template>
  <v-dialog :value="dialog" @click:outside="closeDialog(null)" scrollable max-width="500">
    <ValidationObserver v-slot="{ handleSubmit }">
      <v-card>
        <v-progress-linear v-if="isLoading" indeterminate color="primary" rounded height="6"></v-progress-linear>

        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text"> {{ titleMode }} Campañas </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
            <v-form>
              <v-row dense>
                <!-- Nombre -->
                <v-col cols="12">
                  <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre"
                      name="name"
                      prepend-inner-icon="mdi-label-variant"
                      type="text"
                      color="blue-grey"
                      v-model="formData.name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Fecha IN -->
                <v-col cols="12">
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template
                      v-slot:activator="{
                        on,
                        attrs,
                      }"
                    >
                      <ValidationProvider name="Fecha IN" rules="required" v-slot="{ errors }">
                        <v-text-field
                          v-model="formData.date_IN"
                          label="Fecha IN"
                          prepend-inner-icon="mdi-calendar"
                          class="rounded-small"
                          readonly
                          filled
                          required
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="formData.date_IN"
                      no-title
                      scrollable
                      @input="dateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Fecha EN -->
                <v-col cols="12">
                  <v-menu
                    v-model="date2Menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template
                      v-slot:activator="{
                        on,
                        attrs,
                      }"
                    >
                      <ValidationProvider name="Fecha EN" rules="required" v-slot="{ errors }">
                        <v-text-field
                          v-model="formData.date_EN"
                          label="Fecha EN"
                          prepend-inner-icon="mdi-calendar"
                          class="rounded-small"
                          readonly
                          filled
                          required
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="formData.date_EN"
                      no-title
                      scrollable
                      @input="date2Menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- Hora IN -->
                <v-col cols="6">
                  <ValidationProvider name="Hora IN" rules="required" v-slot="{ errors }">
                    <v-menu
                      v-model="hourMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template
                        v-slot:activator="{
                          on,
                          attrs,
                        }"
                      >
                        <v-text-field
                          v-model="formData.start"
                          label="Hora IN"
                          prepend-inner-icon="mdi-clock-time-four-outline"
                          class="rounded-small"
                          readonly
                          filled
                          required
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="hourMenu"
                        v-model="formData.start"
                        no-title
                        scrollable
                        use-seconds
                        format="24hr"
                        @click:second="hourMenu = false"
                      ></v-time-picker>
                    </v-menu>
                  </ValidationProvider>
                </v-col>

                <!-- Hora EN -->
                <v-col cols="6">
                  <ValidationProvider name="Hora EN" rules="required" v-slot="{ errors }">
                    <v-menu
                      v-model="hour2Menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template
                        v-slot:activator="{
                          on,
                          attrs,
                        }"
                      >
                        <v-text-field
                          v-model="formData.end"
                          label="Hora EN"
                          prepend-inner-icon="mdi-clock-time-four-outline"
                          class="rounded-small"
                          readonly
                          filled
                          required
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          :error-messages="errors"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="hour2Menu"
                        v-model="formData.end"
                        no-title
                        scrollable
                        use-seconds
                        format="24hr"
                        @click:second="hour2Menu = false"
                      ></v-time-picker>
                    </v-menu>
                  </ValidationProvider>
                </v-col>

                <!-- Retries -->
                <v-col cols="12">
                  <ValidationProvider name="Reintentos" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model.number="formData.retries"
                      :error-messages="errors"
                      class="rounded-small"
                      label="Reintentos"
                      name="retries"
                      prepend-inner-icon="mdi-text"
                      color="blue-grey"
                      type="number"
                      dense
                      filled
                      rounded
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Simultaneity -->
                <v-col cols="12">
                  <ValidationProvider name="Simultaneos" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model.number="formData.simultaneity"
                      :error-messages="errors"
                      class="rounded-small"
                      label="Simultaneos"
                      name="simultaneity"
                      prepend-inner-icon="mdi-text"
                      color="blue-grey"
                      type="number"
                      filled
                      dense
                      rounded
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Url Response -->
                <v-col cols="12">
                  <ValidationProvider name="Url de respuesta" rules="" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Url de respuesta"
                      name="url_response"
                      prepend-inner-icon="mdi-image-text"
                      color="blue-grey"
                      v-model="formData.url_response"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Campaign Types -->
                <v-col cols="12">
                  <ValidationProvider name="Tipo de Campaña" rules="required" vid="campaignType" v-slot="{ errors }">
                    <v-select
                      v-model="formData.campaign_type_id"
                      :items="campaignTypesList"
                      :error-messages="errors"
                      item-text="name"
                      item-value="id"
                      class="rounded-small"
                      placeholder="Tipo de Campaña"
                      filled
                      rounded
                      @input="CampaignValue()"
                    ></v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Audio -->
                <v-col cols="12" v-if="formData.campaign_type_id == 3">
                  <ValidationProvider name="Audio" rules="required" v-slot="{ errors }">
                    <v-select
                      :items="audioList"
                      v-model="formData.audio"
                      :error-messages="errors"
                      class="rounded-small"
                      label="Audio"
                      name="audio"
                      prepend-inner-icon="mdi-image-text"
                      color="blue-grey"
                      filled
                      rounded
                      dense
                    ></v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Queue list -->
                <v-col cols="12" v-if="[2, 3, 4, 5].includes(formData.campaign_type_id)">
                  <ValidationProvider rules="required" name="Colas" v-slot="{ errors }" tag="div">
                    <v-select
                      dense
                      filled
                      rounded
                      required
                      color="info"
                      label="Colas"
                      v-model="formData.queue_id"
                      class="rounded-small"
                      :disabled="isLoading"
                      :error-messages="errors"
                      :items="queueList"
                      :item-text="(item) => `${item.name} - ${item.number}`"
                      item-value="id"
                      prepend-inner-icon="mdi-database"
                    >
                      <template slot="item" slot-scope="data"> {{ data.item.name }} ({{ data.item.number }}) </template>
                    </v-select>
                  </ValidationProvider>
                </v-col>

                <!-- Extension list -->
                <v-col cols="12" v-if="[7].includes(formData.campaign_type_id)">
                  <ValidationProvider rules="required" name="extension" v-slot="{ errors }" tag="div">
                    <v-autocomplete
                      dense
                      chips
                      filled
                      rounded
                      required
                      color="info"
                      label="Extensión"
                      class="rounded-small"
                      :items="extensionsList"
                      item-text="extension"
                      item-value="extension"
                      :disabled="isLoading"
                      prepend-inner-icon="mdi-headset"
                      :error-messages="errors"
                      v-model="formData.extension"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <!-- Status -->
                <v-col cols="12" class="px-3">
                  <ValidationProvider name="Estatus" rules="required" v-slot="{ errors }">
                    <v-radio-group v-model="formData.state" :error-messages="errors" row>
                      <template v-slot:label>
                        Estado
                      </template>
                      <v-radio label="Inactiva" :value="0"></v-radio>
                      <v-radio label="Activa" :value="1"></v-radio>
                      <v-radio label="Pausada" :value="2"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </v-col>
                <!-- Assignment agent -->
                <v-col cols="12" class="px-3">
                  <v-checkbox
                    v-model="formData.assignment_agent"
                    label="Agente de asignación"
                    color="primary"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog(null)"
              >Cancelar</v-btn
            >
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
              >{{ submitButtonMode }}</v-btn
            >
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import axios from "axios";
// import { mapState } from "vuex";
import vuescroll from "vuescroll";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: { vuescroll },
  props: {
    dialog: {
      type: Boolean,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    axios: {
      type: Function,
    },
    data: {
      type: Object,
    },
    campaignTypesList: {
      type: Array,
    },
  },
  data() {
    return {
      DIALOG_MAX_HEIGHT,
      isLoading: false,
      queueList: [],
      audioList: [],
      extensionsList: [],
      dateMenu: false,
      date2Menu: false,
      hourMenu: false,
      hour2Menu: false,
      titleMode: this.editMode ? "Actualizar" : "Crear",
      submitButtonMode: this.editMode ? "Guardar" : "Crear",
      formData: this.editMode
        ? this.data
        : {
            name: "",
            date_IN: null,
            date_EN: null,
            start: "08:00:00",
            end: "20:00:00",
            retries: 1,
            simultaneity: 1,
            url_response: "1",
            assignment_agent: false,
            audio: "",
            state: null,
            campaign_type_id: null,
            queue_id: null,
          },
    };
  },

  // computed: {
  //   ...mapState({
  //     extensionItems: (state) => state.callsInfo.allExtension,
  //   }),
  // },

  created() {
    this.axiosInstance = axios.create({
      baseURL: process.env.VUE_APP_ROOTAPI,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    this.getSelectsData();
    this.getAudioList();
    this.getExtensions();
  },

  methods: {
    closeDialog(item) {
      this.$emit("dialog:close", item);
    },

    async getExtensions() {
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get("/clients/listextensOnline", {
          params: { campaign: true },
        });
        this.extensionsList = data;
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener las extensiones.", "¡Error!");
      }
      this.isLoading = false;
    },

    async getSelectsData() {
      this.isLoading = true;
      try {
        const { data } = await this.axiosInstance.get(`/clients/listQueue`);
        this.queueList = data.data;
      } catch (error) {
        this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
        // console.error(error);
      }
      this.isLoading = false;
    },

    async getAudioList() {
      try {
        const { data } = await this.axiosInstance.get(`/campaign/list_audio`);
        // this.queueList = data.data;
        this.audioList = data;
      } catch (error) {
        this.$snotify.error("No se pudo obtener listado de audios.", "¡Error!");
        // console.error(error);
      }
    },

    async submitForm() {
      let data;
      this.isLoading = true;
      try {
        if (this.editMode) {
          // eslint-disable-next-line no-unused-vars
          const { id, ...payload } = this.formData;
          const res = await this.axios.put(`campaign/campaign/${this.data.id}`, payload);
          data = res.data;
          this.$snotify.success("Actualizado con exito", "¡Hecho!");
        } else {
          const res = await this.axios.post("/campaign/campaign", this.formData);
          data = res.data;
          this.$snotify.success("Creado con exito", "¡Hecho!");
        }
        this.closeDialog(data.campaign);
      } catch (err) {
        this.$snotify.error("Hubo un error guardando la campaña", "¡Error!");
        // console.log("Error in post:", err);
      }
      this.isLoading = false;
    },

    CampaignValue() {
      if (this.formData.campaign_type_id == 4 || this.formData.campaign_type_id == 5) {
        const firstQueue = this.queueList[0];
        this.formData.queue_id = firstQueue.id;
      }
    },
  },
};
</script>

<style></style>
